// 更新三维
import { update3Dview } from "@/rlMxModules/threeObject/threeView";
// 新创建 - 模型界面所需数据
export default {
  namespaced: true,
  state: {
    viewFlag: false, // 三维/二维切换 true:3D,false:2D
    drawPlay: false, // 绘图区域按钮切换禁用启用
    isSingleTouch: false, // 单指触摸
    canDraw: true, //当前是否可执行绘制
  },
  mutations: {
    // 设置三维二维切换
    setViewFlag(state, bol) {
      state.viewFlag = bol;
      // 切换三维
      if (bol) {
        update3Dview();
      }
    },
    // 设置绘图区域按钮切换禁用启用
    setDrawPlay(state, bol) {
      state.drawPlay = bol;
    },
    setIsSingleTouch(state, bol) {
      state.isSingleTouch = bol;
    },
    setCanDraw(state, bol) {
      state.canDraw = bol;
    },
  },
  actions: {},
  getters: {},
};
